import React, { PropsWithChildren, useState } from 'react';

import { AuthProvider } from '../auth';
import { printerService } from '../printer/printerService';

import {
  ExaminedContext,
  ExaminedContextInterface,
} from './contexts/ExaminedContext';
import { UserContext, UserContextInterface } from './contexts/UserContext';
import {
  SignInContext,
  SignInContextInterface,
} from './contexts/SignInContext';
import {
  Configuration,
  DefaultApi,
  RequestOpts,
  ResponseError,
} from './autogenerated/spdApiClient';
import { TestContext, TestContextInterface } from './contexts/TestContext';
import { ExamContext, ExamContextInterface } from './contexts/ExamContext';
import {
  ExamTestContext,
  ExamTestContextInterface,
} from './contexts/ExamTestContext';
import {
  ArticleContext,
  ArticleContextInterface,
} from './contexts/ArticleContext';
import {
  BatteriesContext,
  BatteriesContextInterface,
} from './contexts/BatteryContext';
import {
  ResultContext,
  ResultContextInterface,
} from './contexts/ResultContext';
import {
  PdfTemplateContext,
  PdfTemplateContextInterface,
} from './contexts/PdfTemplatesContext';
import {
  JudgmentContext,
  JudgmentContextInterface,
} from './contexts/JudgmentContext';
import {
  PdfPrinterContext,
  PdfPrinterContextInterface,
} from './contexts/PdfPrinterContext';
import {
  FiscalPrinterContext,
  FiscalPrinterContextInterface,
} from './contexts/FiscalPrinterContext';
import { PrinterTokenContext } from './contexts/PrinterTokenContext';
import { CardContext, CardContextInterface } from './contexts/CardContext';
import { NormContext, NormContextInterface } from './contexts/NormContext';
import {
  IndicatorTestContext,
  IndicatorTestContextInterface,
} from './contexts/IndicatorTestContext';
import {
  KeyTestContext,
  KeyTestContextInterface,
} from './contexts/KeyTestContext';
import {
  KeyValueContext,
  KeyValueContextInterface,
} from './contexts/KeyValueContext';
import {
  PositionNormContext,
  PositionNormContextInterface,
} from './contexts/PositionNormContext';
import {
  InterpretationNormContext,
  InterpretationNormContextInterface,
} from './contexts/InterpretationNormContext';
import {
  SupportingExaminationContext,
  SupportingExaminationContextInterface,
} from './contexts/SupportingExaminationContext';
import {
  ConsultationContext,
  ConsultationContextInterface,
} from './contexts/ConsultationContext';
import {
  AttachmentContext,
  AttachmentContextInterface,
} from './contexts/AttachmentContext';
import {
  ExportContext,
  ExportContextInterface,
} from './contexts/ExportContext';
import {
  ExamsPackageContext,
  ExamsPackageContextInterface,
} from './contexts/ExamsPackageContext';
import {
  CompanyContext,
  CompanyContextInterface,
} from './contexts/CompanyContext';
import { StampContext, StampContextInterface } from './contexts/StampContext';
import {
  SavedPdfContext,
  SavedPdfContextInterface,
} from './contexts/SavedPdfContext';
import {
  SzafirContext,
  SzafirContextInterface,
} from './contexts/SzafirContext';
import {
  RegisterContext,
  RegisterContextInterface,
} from './contexts/RegisterContext';
import {
  JudgmentNumberingContext,
  JudgmentNumberingContextInterface,
} from './contexts/JudgmentNumberingContext';
import {
  RegisterNumberingContext,
  RegisterNumberingContextInterface,
} from './contexts/RegisterNumberingContext';
import { EmailContext, EmailContextInterface } from './contexts/EmailContext';
import {
  CertificateContext,
  CertificateContextInterface,
} from './contexts/CertificateContext';
import {
  HealthcareFacilityContext,
  HealthcareFacilityContextInterface,
} from './contexts/HealthcareFacilityContext';
import {
  DocumentationContext,
  DocumentationContextInterface,
} from './contexts/DocumentationContext';
import {
  AccessContext,
  AccessContextInterface,
} from './contexts/AccessContext';
import {
  ExternalReferralContext,
  ExternalReferralContextInterface,
} from './contexts/ExternalReferralContext';
import {
  HarmfulFactorContext,
  HarmfulFactorContextInterface,
} from './contexts/HarmfulFactorContext';
import { DutyContext, DutyContextInterface } from './contexts/DutyContext';
import {
  FiscalPrinterLocationContext,
  FiscalPrinterLocationContextInterface,
} from './contexts/FiscalPrinterLocationContext';
import {
  InvoiceIssuerContext,
  InvoiceIssuerContextInterface,
} from './contexts/InvoiceIssuerContext';
import {
  ReportContext,
  ReportContextInterface,
} from './contexts/ReportContext';
import {
  SupportingExaminationDictContext,
  SupportingExaminationDictContextInterface,
} from './contexts/SupportingExaminationDictContext';
import {
  CalendarContext,
  CalendarContextInterface,
} from './contexts/CalendarContext';
import {
  ExamTypeContext,
  ExamTypeContextInterface,
} from './contexts/ExamTypeContext';
import {
  AppointmentChannelContext,
  AppointmentChannelContextInterface,
} from './contexts/AppointmentChannelContext';
import {
  ExamTypeCategoryContext,
  ExamTypeCategoryContextInterface,
} from './contexts/ExamTypeCategoryContext';
import {
  StethoContext,
  StethoContextInterface,
} from './contexts/StethoContext';
import {
  VisitRegistrationContext,
  VisitRegistrationContextInterface,
} from './contexts/VisitRegistrationContext';
import {
  ExternalVisitBookingContext,
  ExternalVisitBookingContextInterface,
} from './contexts/ExternalVisitBookingContext';
import {
  PricingGroupContext,
  PricingGroupContextInterface,
} from './contexts/PricingGroupContext';
import {
  ReportExcelContext,
  ReportExcelContextInterface,
} from './contexts/ReportExcelContext';
import {
  DownloadsFilesContext,
  DownloadsFilesContextInterface,
} from './contexts/DownloadsFilesContext';
import {
  JobPositionContext,
  JobPositionContextInterface,
} from './contexts/JobPositionContext';
import {
  SynevoContext,
  SynevoContextInterface,
} from './contexts/SynevoContext';
import {
  JobConfigContext,
  JobConfigContextInterface,
} from './contexts/JobConfigContext';
import {
  PaymentContext,
  PaymentContextInterface,
} from './contexts/PaymentContext';
import {
  CustomFieldsContext,
  CustomFieldsContextInterface,
} from './contexts/CustomFieldsContext';
import {
  PricingContext,
  PricingContextInterface,
} from './contexts/PricingContext';
import {
  SalesInvoicesContext,
  SalesInvoicesContextInterface,
} from './contexts/SalesInvoiceContext';
import {
  InvoicePaymentsContext,
  InvoicePaymentsContextInterface,
} from './contexts/InvoicePaymentContext';
import {
  PaymentCollectionsContext,
  PaymentCollectionsContextInterface,
} from './contexts/PaymentCollectionContext';
import {
  ReceiptContext,
  ReceiptContextInterface,
} from './contexts/ReceiptContext';
import {
  DictionaryContext,
  DictionaryContextInterface,
} from './contexts/DictionaryContext';
import {
  DictionaryTypeContext,
  DictionaryTypeContextInterface,
} from './contexts/DictionaryTypeContext';
import {
  PrinterJpkDocumentContext,
  PrinterJpkDocumentContextInterface,
} from './contexts/PrinterJpkDocumentContext';
import {
  ParamsContext,
  ParamsContextInterface,
} from './contexts/ParamsContext';
import {
  ManualContext,
  ManualContextInterface,
} from './contexts/ManualContext';
import {
  JudgmentP1DocumentContext,
  SimP1DocumentContextInterface,
} from './contexts/SimP1DocumentContext';
import {
  ExamBlockContext,
  ExamBlockContextInterface,
} from './contexts/ExamBlockContext';

export interface SpdCoreContextType {
  users: UserContextInterface;
  signIn: SignInContextInterface;
  examineds: ExaminedContextInterface;
  tests: TestContextInterface;
  exams: ExamContextInterface;
  examsPackage: ExamsPackageContextInterface;
  examTests: ExamTestContextInterface;
  articles: ArticleContextInterface;
  results: ResultContextInterface;
  batteries: BatteriesContextInterface;
  pdfTemplates: PdfTemplateContextInterface;
  pdfPrinter: PdfPrinterContextInterface;
  fiscalPrinter: FiscalPrinterContextInterface;
  printerJpkDocuments: PrinterJpkDocumentContextInterface;
  judgments: JudgmentContextInterface;
  cards: CardContextInterface;
  norms: NormContextInterface;
  healthCareFacilities: HealthcareFacilityContextInterface;
  positionNorms: PositionNormContextInterface;
  interpretationNorms: InterpretationNormContextInterface;
  indicatorTests: IndicatorTestContextInterface;
  judgmentNumbering: JudgmentNumberingContextInterface;
  registerNumbering: RegisterNumberingContextInterface;
  keyTests: KeyTestContextInterface;
  keyValues: KeyValueContextInterface;
  support: SupportingExaminationContextInterface;
  consultations: ConsultationContextInterface;
  attachments: AttachmentContextInterface;
  export: ExportContextInterface;
  companies: CompanyContextInterface;
  stamps: StampContextInterface;
  savedPdfs: SavedPdfContextInterface;
  szafir: SzafirContextInterface;
  registers: RegisterContextInterface;
  emails: EmailContextInterface;
  certificates: CertificateContextInterface;
  docs: DocumentationContextInterface;
  accesses: AccessContextInterface;
  externalReferrals: ExternalReferralContextInterface;
  harmfulFactors: HarmfulFactorContextInterface;
  reports: ReportContextInterface;
  reportsExcel: ReportExcelContextInterface;
  duties: DutyContextInterface;
  fiscalPrinterLocations: FiscalPrinterLocationContextInterface;
  invoiceIssuers: InvoiceIssuerContextInterface;
  examTypes: ExamTypeContextInterface;
  supportingExaminationDicts: SupportingExaminationDictContextInterface;
  appointmentChannels: AppointmentChannelContextInterface;
  calendars: CalendarContextInterface;
  examTypesCategories: ExamTypeCategoryContextInterface;
  pricingGroups: PricingGroupContextInterface;
  stetho: StethoContextInterface;
  visits: VisitRegistrationContextInterface;
  externalVisitBooking: ExternalVisitBookingContextInterface;
  downloadsFiles: DownloadsFilesContextInterface;
  jobPositions: JobPositionContextInterface;
  synevo: SynevoContextInterface;
  jobConfig: JobConfigContextInterface;
  payments: PaymentContextInterface;
  customFields: CustomFieldsContextInterface;
  pricing: PricingContextInterface;
  salesInvoices: SalesInvoicesContextInterface;
  invoicePayments: InvoicePaymentsContextInterface;
  paymentCollections: PaymentCollectionsContextInterface;
  receipts: ReceiptContextInterface;
  dictionaries: DictionaryContextInterface;
  dictionaryTypes: DictionaryTypeContextInterface;
  params: ParamsContextInterface;
  manuals: ManualContextInterface;
  judgmentP1Documents: SimP1DocumentContextInterface;
  examBlocks: ExamBlockContextInterface;
}

const getContext: (api: DefaultApi) => SpdCoreContextType = api => {
  printerService.setServerTokenApi(PrinterTokenContext(api));
  return {
    users: UserContext(api),
    docs: DocumentationContext(api),
    signIn: SignInContext(),
    examineds: ExaminedContext(api),
    tests: TestContext(api),
    exams: ExamContext(api),
    examsPackage: ExamsPackageContext(api),
    examTests: ExamTestContext(api),
    articles: ArticleContext(api),
    results: ResultContext(api),
    batteries: BatteriesContext(api),
    pdfTemplates: PdfTemplateContext(api),
    pdfPrinter: PdfPrinterContext(api),
    fiscalPrinter: FiscalPrinterContext(api),
    printerJpkDocuments: PrinterJpkDocumentContext(api),
    judgments: JudgmentContext(api),
    cards: CardContext(api),
    norms: NormContext(api),
    positionNorms: PositionNormContext(api),
    healthCareFacilities: HealthcareFacilityContext(api),
    interpretationNorms: InterpretationNormContext(api),
    indicatorTests: IndicatorTestContext(api),
    judgmentNumbering: JudgmentNumberingContext(api),
    registerNumbering: RegisterNumberingContext(api),
    keyTests: KeyTestContext(api),
    keyValues: KeyValueContext(api),
    support: SupportingExaminationContext(api),
    consultations: ConsultationContext(api),
    attachments: AttachmentContext(api),
    export: ExportContext(api),
    companies: CompanyContext(api),
    stamps: StampContext(api),
    savedPdfs: SavedPdfContext(api),
    szafir: SzafirContext(api),
    registers: RegisterContext(api),
    emails: EmailContext(api),
    certificates: CertificateContext(api),
    accesses: AccessContext(api),
    harmfulFactors: HarmfulFactorContext(api),
    reports: ReportContext(api),
    reportsExcel: ReportExcelContext(api),
    duties: DutyContext(api),
    fiscalPrinterLocations: FiscalPrinterLocationContext(api),
    invoiceIssuers: InvoiceIssuerContext(api),
    externalReferrals: ExternalReferralContext(api),
    examTypes: ExamTypeContext(api),
    supportingExaminationDicts: SupportingExaminationDictContext(api),
    appointmentChannels: AppointmentChannelContext(api),
    calendars: CalendarContext(api),
    examTypesCategories: ExamTypeCategoryContext(api),
    pricingGroups: PricingGroupContext(api),
    stetho: StethoContext(api),
    visits: VisitRegistrationContext(api),
    externalVisitBooking: ExternalVisitBookingContext(api),
    downloadsFiles: DownloadsFilesContext(api),
    jobPositions: JobPositionContext(api),
    synevo: SynevoContext(api),
    jobConfig: JobConfigContext(api),
    payments: PaymentContext(api),
    customFields: CustomFieldsContext(api),
    pricing: PricingContext(api),
    salesInvoices: SalesInvoicesContext(api),
    invoicePayments: InvoicePaymentsContext(api),
    paymentCollections: PaymentCollectionsContext(api),
    receipts: ReceiptContext(api),
    dictionaries: DictionaryContext(api),
    dictionaryTypes: DictionaryTypeContext(api),
    params: ParamsContext(api),
    manuals: ManualContext(api),
    judgmentP1Documents: JudgmentP1DocumentContext(api),
    examBlocks: ExamBlockContext(api),
  };
};

class APIWithHandler extends DefaultApi {
  constructor(
    configuration: Configuration,
    // private responseExceptionHandler: (response: Response) => Response,
    // private runExclusive: (callback: () => Promise<void>) => Promise<void>,
  ) {
    super(configuration);
  }
  protected async request(context: RequestOpts): Promise<Response> {
    const token = localStorage.getItem(AuthProvider.TOKEN_KEY) || undefined;
    context.headers['Authorization'] = 'Bearer ' + token;

    const twoFactorToken = localStorage.getItem(
      AuthProvider.TWO_FACTOR_TOKEN_KEY,
    );
    if (twoFactorToken) {
      context.headers['X-2FA-Session'] = twoFactorToken;
    }

    try {
      return await super.request(context);
    } catch (err) {
      if (err instanceof ResponseError && err.response.status === 403) {
        try {
          const body = await err.response.clone().json();
          if (body?.code === '2FA_SESSION_EXPIRED') {
            window.dispatchEvent(new CustomEvent('session-inactive'));
            await new Promise(() => {}); // hold — redirect fires in handleSessionInactive
          } else if (
            body?.code === 'SESSION_INACTIVE' ||
            body?.code === '2FA_REQUIRED'
          ) {
            window.dispatchEvent(new CustomEvent('tfa-required'));
            await new Promise(() => {}); // hold — 2FA screen shows in handleTfaRequired
          }
        } catch {
          // non-JSON 403, ignore
        }
      }
      throw err;
    }
  }
}

export const SpdCoreContext = React.createContext(
  getContext(
    new APIWithHandler(
      new Configuration({
        basePath: process.env.REACT_APP_SPDAPI_URL,
      }),
    ),
  ),
);

export const SpdCoreProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [context, setDefaultContext] = useState(
    getContext(
      new APIWithHandler(
        new Configuration({
          basePath: process.env.REACT_APP_SPDAPI_URL,
        }),
      ),
    ),
  );
  const value = React.useMemo(
    () => ({
      ...context,
      setDefaultContext,
    }),
    [context],
  );

  return (
    <SpdCoreContext.Provider value={value}>{children}</SpdCoreContext.Provider>
  );
};
